import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { viewChat, hasPermission } from 'actions';
import { updateUserSettings } from 'actions/connect';

class SettingsArea extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    	body : '',
    	showModal: false,
			feed: ''
    }

    this.socket = this.props.socket;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleReturnToChat = this.handleReturnToChat.bind(this);
    this.handleSubmitScreenNameChange = this.handleSubmitScreenNameChange.bind(this);
    this.checkForEnter = this.checkForEnter.bind(this);
    this.handleChangeScreennameClick = this.handleChangeScreennameClick.bind(this);
		this.handleChangeFeedClick = this.handleChangeFeedClick.bind(this);
    this.toggleChatState = this.toggleChatState.bind(this);
    this.handleClearMessages = this.handleClearMessages.bind(this);
    this.handleChangeAvatar = this.handleChangeAvatar.bind(this);
		this.handleFeedChange = this.handleFeedChange.bind(this);
  }

  handleInputChange(event) {
		if(event.target.id == 'feedChangeInput') {
			return this.setState({ feed: event.target.value });
		}

  	this.setState({body : event.target.value});
  }

  handleReturnToChat() {
  	this.props.viewChat();
  }

  handleSubmitScreenNameChange() {
  	if(typeof this.props.onScreenNameChange === 'function')
  		this.props.onScreenNameChange(this.state.body);
  	this.setState({body:''});
  }

  handleChangeScreennameClick() {
  	this.refs.focusedInput.focus();
  }

	handleChangeFeedClick() {
		this.refs.feedFocusedInput.focus();
	}

	handleFeedChange() {
		if (this.props.onFeedChange) {
  		this.props.onFeedChange(this.state.feed);
		}

		this.setState({feed: ''});
	}

	toggleChatState() {
		const newState = !this.props.liveWeatherCenter.status.enabled;

		if(newState) {
			this.props.onEnable();
		}
		else {
			this.props.onDisable();
		}
	}

  handleClearMessages() {
  	if (this.props.onClear)
  		this.props.onClear();
  }

  handleChangeAvatar(avatar) {
  	if(this.props.onAvatarChange){
  		this.props.onAvatarChange(avatar);
		}
  }

  checkForEnter(event) {
  	if (event.key === 'Enter') {
			if(event.target.id === 'feedChangeInput') {
				return this.handleFeedChange();
			}
  		this.handleSubmitScreenNameChange();
  	}
  }

  render() {
		const chatEnabled = this.props.liveWeatherCenter.status.enabled;
		const chatStateBtnMsg = chatEnabled ? 'Disable Chat' : 'Enable Chat';

    return (
    	<div>
	    	<div className="panel-body group-chat-panel">

	    		<p>Example</p>
	      	<div className="message-wrapper mb-lg">
		  			<div className="my-message-bubble">
	  					<div className="avatar-img">
								<img style={{maxWidth:"100%"}} src={this.props.user.avatar}/>
							</div>
							<div className="message">
								<div><strong>{this.props.user.screen_name}</strong> at  {new Date().toLocaleTimeString()}</div>
		  					<p>Sample Message</p>
		  				</div>
		  			</div>
		  		</div>
	      	<div className="panel-group settings-accordian" id="accordionPrimary">
			  		<div className="panel panel-accordion panel-accordion-primary">
							<div className="panel-heading">
								<h4 className="panel-title">
									<a
										onClick={this.handleChangeScreennameClick}
										className="accordion-toggle collapsed"
										data-toggle="collapse"
										data-parent="#accordionPrimary"
										href="#collapsePrimaryOne"
										aria-expanded="false">
										 Change Screen Name
									</a>
								</h4>
							</div>
							<div
								id="collapsePrimaryOne"
								className="accordion-body collapse"
								aria-expanded="false">
								<div className="change-screenname">
									<div
										className="input-group"
										style={{padding: '3px'}}>
										<input
											ref="focusedInput"
											type="text"
											className="form-control"
											placeholder="Screen Name"
											value={this.state.body}
											onChange={this.handleInputChange}
											onKeyPress={this.checkForEnter}/>
										<span className="input-group-btn">
											<div
						          	onClick={this.handleSubmitScreenNameChange}
												className="btn btn-primary"
												type="submit">Submit
						          </div>
										</span>
									</div>
								</div>
							</div>
						</div>
			  		<div className="panel panel-accordion panel-accordion-primary">
							<div className="panel-heading">
								<h4 className="panel-title">
									<a
										className="accordion-toggle collapsed"
										data-toggle="collapse"
										data-parent="#accordionPrimary"
										href="#collapsePrimaryTwo">
										 Change Avatar
									</a>
								</h4>
							</div>
							<div
								id="collapsePrimaryTwo"
								className="accordion-body collapse"
								aria-expanded="false">
								<div className="row avatar-settings">
									<img src={this.props.user.avatar ? this.props.user.avatar : this.props.liveWeatherCenter.default_avatar} />
								</div>
								<div
									className="row avatar-choices"
									style={{'overflowY' : 'auto'}}>
									{this.props.liveWeatherCenter.avatars.map((avatar, index) => {
										return <div key={index}
											onClick={f => this.handleChangeAvatar(avatar)}
											className="col-xs-3 col-s-3 col-md-3 col-lg-3 col-xl-3 avatar-in-grid">
											<img style={{'maxWidth': '100%'}} src={avatar} />
										</div>
									})}
								</div>
							</div>
						</div>
	        </div>
	        {(() => {
	        	if (this.props.hasPermission('/Live Weather Center/Administrate Chat/')) {
							return (
								<div>
									<div className="panel-group settings-accordian" id="accordionFeed">
										<div className="panel panel-accordion panel-accordion-primary">
											<div className="panel-heading">
												<h4 className="panel-title">
													<a
														onClick={this.handleChangeFeedClick}
														className="accordion-toggle collapsed"
														data-toggle="collapse"
														data-parent="#accordionPrimary"
														href="#collapseFeedChange"
														aria-expanded="false">
														 Change Feed
													</a>
												</h4>
											</div>
											<div
												id="collapseFeedChange"
												className="accordion-body collapse"
												aria-expanded="false">
												<div className="change-feed">
													<div
														className="input-group"
														style={{padding: '3px'}}>
														<input
															ref="feedFocusedInput"
															id="feedChangeInput"
															type="text"
															className="form-control"
															placeholder="Feed URL"
															value={this.state.feed}
															onChange={this.handleInputChange}
															onKeyPress={this.checkForEnter}/>
														<span className="input-group-btn">
															<div
																onClick={this.handleFeedChange}
																className="btn btn-primary"
																type="submit">Submit
															</div>
														</span>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div
										className={`enable-button btn btn-block btn-${chatEnabled ? 'danger' : 'success'}`}
										onClick={this.toggleChatState}>
										{ chatStateBtnMsg }
									</div>

									<div
										className="enable-button btn btn-block btn-default"
										onClick={this.handleClearMessages}>
										Clear All Messages
									</div>
								</div>

							)
	        	}
	        })()}
        </div>
    	{(()=>{
    		if(!this.props.user.screen_name || !this.props.user.avatar)
    			return <div className="alert alert-warning">Please choose a screen name and avatar before you chat.</div>
    		else
    			return (
				<div
					className="btn btn-block btn-primary"
					onClick={this.handleReturnToChat}>
		        		Return To Chat
		        </div>

    			);
    	})()}
      </div>
  	);
	}
}

function mapStateToProps({connection, liveWeatherCenter}) {
	return {
		user : connection.user,
		liveWeatherCenter
	};
}

export default connect(mapStateToProps, { viewChat, hasPermission })(SettingsArea)



// WEBPACK FOOTER //
// ./src/browser/components/live_weather_center/chat/settings/settings_area.js